import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"
import styles from "../../../styles/Participant-Employment.module.css"
import TextField from "../Utils/TextField"
import PhoneField from "../Utils/PhoneField"
import DropdownField from "../Utils/DropdownField"
import { TransitionContactType } from "../Types/Dropdowns"
import CheckboxField from "../Utils/CheckboxField"
import { useEffect, useState } from "react"
import { InputText } from "primereact/inputtext"
import { validateEmail } from "../Utils/Utils"
const ContactForm = ({
  visible,
  setVisible,
  edit,
  setValue,
  contacts,
  setEdit,
}) => {
  const [name, setName] = useState("")
  const [typesOfSupport, setTypeOfSupport] = useState("")
  const [contactType, setContactType] = useState("")
  const [supportPhone, setSupportPhone] = useState("")
  const [schedule, setSchedule] = useState(false)
  const [email, setEmail] = useState("")
  const [errors, setErrors] = useState({})
  const { v4: uuidv4 } = require("uuid")

  useEffect(() => {
    if (edit) {
      setName(edit.name)
      setTypeOfSupport(edit.typesOfSupport)
      setContactType(edit.contactType)
      setSupportPhone(edit.supportPhone)
      setSchedule(edit.schedule)
      setEmail(edit.email)
    }
  }, [edit])

  const validateFields = () => {
    let errors = {}
    if (email) {
      if (!validateEmail(email)) {
        errors.email = "Invalid email address"
      }
    }
    setErrors(errors)
    return Object.keys(errors).length === 0
  }
  const clearForm = () => {
    setName("")
    setTypeOfSupport("")
    setContactType("")
    setSupportPhone("")
    setSchedule(false)
    setEmail("")
    setErrors({})
  }
  const footer = () => {
    return (
      <div className={styles.education_form_footer}>
        <Button
          label="Cancel"
          type="button"
          onClick={() => {
            clearForm()
            setEdit(null)
            setVisible(false)
          }}
          className={`${styles.button} ${styles.button_secondary}`}
        />
        <Button
          label={`${edit ? "Edit" : "Create"} contact`}
          style={{ marginLeft: "1rem" }}
          type="button"
          className={`${styles.button}`}
          onClick={() => {
            saveContacts()
          }}
        />
      </div>
    )
  }
  const header = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          borderBottom: "solid 3px #e7e0f1",
          marginBottom: "20px",
        }}
      >
        <p
          style={{
            fontSize: "24px",
            fontWeight: "700",
            lineHeight: "33px",
            marginBottom: "20px",
            marginTop: "10px",
          }}
        >{`${edit ? "Edit" : "Add new"} contact`}</p>
        <Button
          className={styles.rounded_btn}
          icon="pi pi-times"
          onClick={() => {
            clearForm()
            setVisible(false)
          }}
          style={{ marginTop: "10px" }}
        />
      </div>
    )
  }
  const saveContacts = () => {
    if (validateFields()) {
      if (edit) {
        const newSave = contacts?.map((s) => {
          let newValue = { ...s }
          if (s.name === edit?.name) {
            newValue.name = name
            newValue.typesOfSupport = typesOfSupport
            newValue.contactType = contactType
            newValue.supportPhone = supportPhone
            newValue.schedule = schedule
            newValue.email = email
          }
          return newValue
        })
        setValue(newSave)
        setEdit(null)
      } else {
        setValue([
          {
            name,
            typesOfSupport,
            contactType,
            supportPhone,
            schedule,
            email,
            id: uuidv4(),
          },
          ...contacts,
        ])
      }
      setVisible(false)
      clearForm()
    }
  }
  return (
    <Dialog visible={visible} style={{ width: "50vw" }} showHeader={false}>
      {header()}
      <>
        <div
          className={styles.field}
          style={{ marginBottom: "0rem", width: "100%" }}
        >
          <label className={`${styles.label}`} style={{ marginBottom: "5px" }}>
            {"Name"}
          </label>
          <InputText
            value={name}
            style={{ width: "100%" }}
            onChange={(e) => {
              setName(e.target.value)
            }}
            className={errors.name ? "p-invalid" : ""}
          />
        </div>
        {errors.name && errors.name}
      </>
      <TextField
        label={"Types of support preferred"}
        value={typesOfSupport}
        setValue={setTypeOfSupport}
      />
      <div style={{ display: "flex", justifyContent: "start", gap: "15px" }}>
        <DropdownField
          label={"Contact type"}
          options={TransitionContactType}
          value={contactType}
          setValue={setContactType}
          size={"50"}
        />
        <div style={{ width: "50%" }}>
          <PhoneField
            label={"Support phone"}
            value={supportPhone}
            setValue={setSupportPhone}
            style={{ width: "100%" }}
            lblStyle={{ marginTop: "0px", marginBottom: "6px" }}
          />
        </div>
      </div>
      <div
        className={styles.field}
        style={{ marginBottom: "0rem", width: "100" }}
      >
        <label className={`${styles.label}`} style={{ marginBottom: "5px" }}>
          {"Email"}
        </label>
        <InputText
          value={email}
          style={{ width: "100%" }}
          onChange={(e) => {
            setEmail(e.target.value)
            setErrors({ ...errors, email: "" })
          }}
          className={errors.email ? "p-invalid" : ""}
        />
        {errors.email && <span style={{ color: "red" }}>{errors.email}</span>}
      </div>
      <div style={{ marginTop: "20px" }}>
        <CheckboxField
          label={
            "Should we schedule a meeting with this support contact to discuss the transition?"
          }
          setValue={setSchedule}
          single
          value={schedule}
        />
      </div>
      {footer()}
    </Dialog>
  )
}
export default ContactForm
